var map = {
	"./an-updated-model-for-motive-classification.md": "f031",
	"./how-does-the-CNN-classifier-work.md": "485e",
	"./new-models-for-automated-motive-coding.md": "ee46",
	"./why-automate-implicit-motive-coding.md": "6028"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9784";